














































































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  BarisBlokRekap,
  BlokRekap,
  DefinisiRekap,
  KolomRekap,
  NilaiRekap
} from "@/services/LaporanKebidanan";

@Component({})
export default class MatriksBulananKebidanan extends Vue {
  @Prop({ type: Object, required: true }) readonly blok!: BlokRekap;
  @Prop({ type: Array, required: true }) readonly kolom!: KolomRekap[];
  @Prop({ type: Object, required: true }) readonly nilai!: NilaiRekap;
  @Prop({ type: Object, required: true }) readonly rme!: NilaiRekap;
  @Prop({ type: Object, required: true })
  readonly akhir!: Record<string, number | null>;
  @Prop({ type: Object, required: true })
  readonly definisi!: Record<string, DefinisiRekap>;
  @Prop({ type: Object, required: true })
  readonly dikoreksi!: Record<string, boolean>;
  @Prop({ type: Object, default: () => ({}) })
  readonly draft!: Record<string, number>;
  @Prop({ type: Object, default: () => ({}) })
  readonly rincian!: Record<string, Record<string, number[]>>;
  @Prop({ type: Object, default: () => ({}) })
  readonly asal!: Record<string, string>;
  @Prop({ type: Boolean, default: false }) readonly bolehUbah!: boolean;

  get grup(): string[] {
    return (this.blok.judul_grup || []).filter(g => g !== "");
  }

  get adaNo(): boolean {
    return !!this.blok.judul_no;
  }

  get judulLabel(): string {
    return this.blok.judul_label || this.blok.label_tahun;
  }

  bisaIsi(b: BarisBlokRekap, k: KolomRekap): boolean {
    return this.bolehUbah && b.ubah && k.koreksi_berlaku;
  }

  nilaiSel(kunci: string, kolomId: string): number | null {
    const baris = this.nilai[kunci];
    const v = baris ? baris[kolomId] : null;

    return v === undefined ? null : v;
  }

  rmeSel(kunci: string, kolomId: string): number | null {
    const baris = this.rme[kunci];
    const v = baris ? baris[kolomId] : null;

    return v === undefined ? null : v;
  }

  tampilInput(b: BarisBlokRekap, k: KolomRekap): string {
    const kunci = k.id + "|" + b.key;

    if (Object.prototype.hasOwnProperty.call(this.draft, kunci)) {
      return String(this.draft[kunci]);
    }

    const v = this.rmeSel(b.key, k.id);

    return v === null ? "" : String(v);
  }

  adaRincian(b: BarisBlokRekap, k: KolomRekap): boolean {
    const r = this.rincian[b.key];

    return !!r && !!r[k.id] && r[k.id].length > 0;
  }

  desimal(kunci: string): boolean {
    const d = this.definisi[kunci];

    return !!d && !!d.rumus && d.rumus.op === "persen";
  }

  format(v: number | null | undefined, desimal: boolean): string {
    if (v === null || v === undefined) return "";

    return desimal
      ? v.toLocaleString("id-ID", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      : String(v);
  }

  labelKolom(k: KolomRekap): string {
    const i = this.kolom.findIndex(x => x.id === k.id);

    return this.blok.label_kolom[i] || k.id;
  }

  judulBaris(b: BarisBlokRekap): string {
    if (!b.ubah && this.asal[b.key]) {
      return "Mengikuti baris " + this.asal[b.key];
    }

    const d = this.definisi[b.key];

    return d ? d.aturan : "";
  }

  tooltip(b: BarisBlokRekap, k: KolomRekap): string {
    const d = this.definisi[b.key];

    if (!d || d.jenis === "turunan") return d ? d.aturan : "";

    if (!k.berjalan) return "Bulan belum berjalan";

    const rme = this.rmeSel(b.key, k.id);

    if (this.dikoreksi[k.id + "|" + b.key]) {
      return rme === null
        ? "Isian PIC (baris ini tanpa sumber RME)"
        : "Dikoreksi PIC — hitungan RME: " + rme;
    }

    if (d.jenis === "manual") {
      return "Belum ada sumber data di RME — diisi PIC";
    }

    return "Hitungan RME";
  }
}
